import React, { useEffect } from "react";

export default function Toast({ message, onClose, style = {} }) {
  useEffect(() => {
    const timer = setTimeout(onClose, 5000); // show for 5 seconds
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div
      style={{
        position: "fixed",
        padding: "14px 22px",
        background: "#004A8F",   // <-- updated to match your button color
        color: "white",
        fontSize: "15px",
        borderRadius: "10px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
        opacity: 1,
        animation: "fadeIn 0.4s ease-out",
        ...style, // merge caller overrides
      }}
    >
      {message}

      {/* Fade-in keyframes */}
      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(6px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}
      </style>
    </div>
  );
}
